import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBwouSCh3qCDkdf68hvBaw7TBSdT83ZnTU",
  authDomain: "autocat-1b0cc.firebaseapp.com",
  projectId: "autocat-1b0cc",
  storageBucket: "autocat-1b0cc.firebasestorage.app",
  messagingSenderId: "41162714084",
  appId: "1:41162714084:web:49aa603aa1487a8268b5f1",
  measurementId: "G-EGZ3DDNM5C"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;